import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class ExpenseStatusesDisplayListCtrl implements IController {
  ids: any;
  isRow: any;
  rowLimit: any;
  onChange: Function;

  private displayItems: any;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    // if (this.ids && this.ids.length) {
    //
    // } else {
    //   this.displayItems = [];
    // }
    if (!this.rowLimit) {
      this.rowLimit = 10;
    }
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }


}

angular
  .module('bringoz.admin.expenses')
  .component('expenseStatusesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./expense-statuses-display-list.html').default,
    controller: ExpenseStatusesDisplayListCtrl
  });
